import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '_atoms/Typography';
import { Status } from '_atoms/Status';
import { getStatusType } from '_molecules/JobCandidateInfo/utils';
import type { TFunction } from 'i18next';
import type { JobAssignedRow } from './utils';

export const useColumns = (t: TFunction) => [
  {
    title: t('translation:job_assigned_tab_content.column_job_step'),
    dataIndex: 'job_step',
    key: 'job_step',
    width: 180,
    render: (value: unknown) => {
      const data = value as JobAssignedRow['job_step'];
      return (
        <Link to={data.link} className="candidate-link">
          <Typography.Text>{data.job}</Typography.Text>
          <Typography.Caption>{data.step}</Typography.Caption>
        </Link>
      );
    },
  },
  {
    title: t('translation:job_assigned_tab_content.column_candidate_status'),
    dataIndex: 'status',
    key: 'status',
    width: 164,
    render: (value: unknown) => {
      const data = value as string;
      return <Status type={getStatusType(data)}>{data}</Status>;
    },
  },
  {
    title: t('translation:job_assigned_tab_content.column_responsible_recruiter'),
    dataIndex: 'recruiter',
    key: 'recruiter',
    width: 180,
  },
  {
    title: t('translation:job_assigned_tab_content.column_responsible_team_lead'),
    dataIndex: 'team_lead',
    key: 'team_lead',
    width: 180,
  },
];
